<template>
 <section>
  <div class="container alldatadiv"  :class="{generictddivcss: generictddiv === 'generictddivcss'}" :bgcolor='False'>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 rounded datadiv0" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
            <div class="formatmydiv" v-html="opssection1" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300"></div>
        </div>
 
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 rounded datadiv1" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300">
          <table class="tablewidth">
            <tr  v-for="dtd in tabledata" class="formatrow" data-aos-duration="1000" data-aos-delay="300">
              <td v-html="`trim(${dtd.documentdesc})`" class="formattd"></td>
              <td><a :href="`${myPicUrl}${dtd.document}`" class="formattd1"><i class="fa-solid fa-download" style="padding-right: 15px;"></i></a></td>
          
            </tr>
          </table>
        </div>
      </div>
  </div>
</section>
</template>


<script>
require('@/globalDeclare.js');
export default {
  props: ['tabledata', 'generictddiv', 'opssection1', 'bgcolor'],

  data(){
    return {
      myPicUrl: '',
    }
  },

  mounted() {
    this.myPicUrl = myUrlPath
  }
}
</script>

<style scoped>

.datadiv0 {
  font-size: 12px;
  width: 40%;
}
.formatmydiv {
  font-size: 18px;;
}
.datadiv1 {
  font-size: 12px;
  width: 60%;
  overflow-y: scroll;
}

.datalinks {
  text-decoration: none;
  font-size: 18px;
  text-align: left;
}

.alldatadiv{
  width: 100%;
  margin: 0 auto;

}
tr:nth-of-type(odd)
{  
background-color: rgb(231, 229, 229);
}
tr:nth-of-type(even)
{  
background-color: rgb(156, 176, 182);
}

.formatrow {
  text-align: left;
  padding: 20px;
}

.formattd, .datadiv0 {
  text-align: left;
  padding: 20px;
  font-size: 16px;
  color: #003;
}

.fa-download {
  font-size: 28px;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .datadiv0 {
    font-size: 12px;
    width: 100%;
  }
  
  .datadiv1 {
    font-size: 12px;
    width: 100%;
  }
     
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .datadiv0 {
    font-size: 12px;
    width: 100%;
  }
  
  .datadiv1 {
    font-size: 12px;
    width: 100%;
  }


}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .datadiv0 {
    font-size: 12px;
    width: 100%;
  }
  
  .datadiv1 {
    font-size: 12px;
    width: 100%;
  }
  table {
    width: 100%;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

  .datadiv0 {
    font-size: 12px;
    width: 50%;
  }
  
  .datadiv1 {
    font-size: 12px;
    width: 50%;
  }
  .tablewidth {
    width: 100%;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .datadiv0 {
    font-size: 12px;
    width: 50%;
  }
  
  .datadiv1 {
    font-size: 12px;
    width: 50%;
  }
  .tablewidth {
    width: 100%;
  }
} 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
  .datadiv0 {
    font-size: 12px;
    width: 50%;
  }
  
  .datadiv1 {
    font-size: 12px;
    width: 50%;
  }
  .alldatadiv {
    width: 80%;
  }
  .tablewidth {
    width: 100%;
  }
} 
</style>
